export const ELEMENT_IDS = {
  // Common Navigation Buttons
  SKIP_BUTTON: 'skip-button',
  NEXT_STEP_BUTTON: 'next-step-button',
  PREVIOUS_STEP_BUTTON: 'previous-step-button',
  DEFAULT_BUTTON: 'default-button-id',
  NAVIGATE_TO_SC: 'navigate-sc-login',
  NAVIGATE_TO_SC_LOGIN: 'navigate-sc_login',
  ADDRESS_INPUT: 'address-input',

  // Checkout Page IDs
  CHECKOUT_SERVICE_ADDRESS: 'checkout-service-address',
  CHECKOUT_SHIPPING_ADDRESS: 'checkout-shipping-address',
  PROCEED_BUTTON: 'proceed-button',
  CHECKOUT_PLAN_NAME: 'checkout-plan-name',
  CHECKOUT_PLAN_PRICE: 'checkout-plan-price',
  CHECKOUT_PLAN_INSTALL_DATE: 'checkout-plan-install-date',
  CHECKOUT_PLAN_TERMS_LINK: 'checkout-plan-terms-link',

  CHECKOUT_ADDON_NAME: 'checkout-addon-name',
  CHECKOUT_ADDON_PRICE: 'checkout-addon-price',
  CHECKOUT_ADDON_INSTALL_DATE: 'checkout-addon-install-date',
  CHECKOUT_ADDON_TERMS_LINK: 'checkout-addon-terms-link',

  CHECKOUT_ORDER_TOTAL: 'checkout-order-total',
  CHECKOUT_ORDER_VALUE: 'checkout-order-value',
  CHECKOUT_MODEM_RENTAL: 'checkout-modem-rental',
  CHECKOUT_TAX: 'checkout-tax',
  CHECKOUT_DISCOUNT: 'checkout-discount',

  // Order Summary Detail IDs
  CHECKOUT_PLAN_NAME_SUMMARY: 'checkout-plan-name-summary',
  CHECKOUT_PLAN_PRICE_SUMMARY: 'checkout-plan-price-summary',
  CHECKOUT_ADDON_NAME_SUMMARY: 'checkout-addon-name-summary',
  CHECKOUT_ADDON_PRICE_SUMMARY: 'checkout-addon-price-summary',

  CHECKOUT_PROCEED_BUTTON: 'checkout-proceed-button',
  GET_NOTIFIED: 'get-notified',

  AUTOPAY_YES: 'autopay-yes',
  AUTOPAY_NO: 'autopay-no',
  PAPERLESS_YES: 'paperless-yes',
  PAPERLESS_NO: 'paperless-no',

  // Setup Account Page
  ACCOUNT_FIRST_NAME: 'account-first-name',
  ACCOUNT_LAST_NAME: 'account-last-name',
  ACCOUNT_PHONE: 'account-phone',
  ACCOUNT_VERIFY_PHONE_LINK: 'account-verify-phone-link',
  ACCOUNT_EMAIL: 'account-email',
  ACCOUNT_EMAIL_VERIFIED_STATUS: 'account-email-verified-status',
  ACCOUNT_ADDRESS: 'account-address',
  ACCOUNT_PASSWORD: 'account-password',
  ACCOUNT_TOGGLE_PASSWORD: 'account-toggle-password',
  ACCOUNT_PASSWORD_STRENGTH_BAR: 'account-password-strength-bar',
  ACCOUNT_CONFIRM_PASSWORD: 'account-confirm-password',
  CREATE_ACCOUNT_BUTTON: 'create-account-button',

  // Order Confirmation Page IDs
  ORDER_USER_NAME: 'order-user-name',
  ORDER_ACCOUNT_NAME: 'order-account-name',
  ORDER_PHONE: 'order-phone',
  ORDER_EMAIL: 'order-email',
  ORDER_ADDRESS: 'order-address',

  PLAN_NAME: 'plan-name',
  PLAN_PRICE: 'plan-price',
  PLAN_INSTALL_DATE: 'plan-install-date',
  PLAN_TERMS_LINK: 'plan-terms-link',

  ADDON_NAME: 'addon-name',
  ADDON_PRICE: 'addon-price',
  ADDON_INSTALL_DATE: 'addon-install-date',
  ADDON_TERMS_LINK: 'addon-terms-link', 
   TERMS_AND_CONDITIONS_LINK: 'terms-and-conditions-link',

};

